import React, { useEffect, useState } from "react";
import axios from "axios";
import { unserialize } from "php-serialize";
import { Buffer } from "buffer";
import { BaseUrl } from "../App";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


window.Buffer = Buffer;

const LabelsSettings = () => {
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [menuData, setMenuData] = useState({});
  const [activeTab, setActiveTab] = useState("admin_labels");
  const [decodedLanguages, setDecodedLanguages] = useState([]);
   const [loading, setLoading] = useState(false);

  const [languageStatus, setLanguageStatus] = useState("");
  const [inputValues, setInputValues] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [newState, setnewState] = useState("N");
  const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("")

    useEffect(() => {
      let timer;
      if (error) {
        timer = setTimeout(() => {
          setError("");
        }, 5000); // 5 seconds
      }
      return () => clearTimeout(timer);
    }, [error]);
  useEffect(() => {
    fetchLanguages();
  }, []);

  const decodeBase64 = (base64String) => {
    try {
      return atob(base64String);
    } catch (error) {
      console.error("Error decoding Base64:", error);
      return null;
    }
  };

  const handleToggle = async () => {
    const newState = !isChecked;
    const newStateValue = newState ? "Y" : "N";
    setIsChecked(newState);
setLoading(true);

    try {
      const payload = {
        action: "change_language_status",
        lang: selectedLanguage,
        language_status: newStateValue,
      };

      const response = await axios.post(
        `${BaseUrl}/backend/api/language_labels.php`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        setSuccessMessage("Change Status Successfully!")
        console.log("API Response:", response.data);
      } else {
        console.log("API response indicates failure:", response.data);
      }
    } catch (error) {
      console.log("Error making API request:", error);
    }   finally {
      setLoading(false);
    }
  };

  const fetchLanguages = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/language_labels.php`,
        { action: "get_all_languages", api_key: "1" },
        { headers: { "Content-Type": "application/json" } }
      );

      const rawData = response.data.data;

      const processedData = rawData.map((language) => ({
        ...language,
        admin_labels: language.admin_labels
          ? unserialize(decodeBase64(language.admin_labels))
          : {},
        app_labels: language.app_labels
          ? unserialize(decodeBase64(language.app_labels))
          : {},
        error_labels: language.error_labels
          ? unserialize(decodeBase64(language.error_labels))
          : {},
        extra_labels: language.extra_labels
          ? unserialize(decodeBase64(language.extra_labels))
          : {},
        front_error_labels: language.label_data
          ? unserialize(decodeBase64(language.label_data))
          : {},
      }));

      setDecodedLanguages(processedData);
      setLanguages(processedData);
    } catch (error) {
      console.error("Error fetching languages:", error);
    }   finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setInputValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleLanguageChange = (e) => {
    const language = e.target.value;
    setSelectedLanguage(language);

    const selectedLangData = decodedLanguages.find(
      (lang) => lang.language === language
    );

    if (selectedLangData) {
      setMenuData({
        admin_labels: selectedLangData.admin_labels || {},
        app_labels: selectedLangData.app_labels || {},
        error_labels: selectedLangData.error_labels || {},
        extra_labels: selectedLangData.extra_labels || {},
        front_error_labels: selectedLangData.front_error_labels || {},
      });
      setActiveTab("admin_labels");
      setLanguageStatus(selectedLangData.language_status);
      setIsChecked(selectedLangData.language_status === "Y");
    }
  };

  const handleSave = async () => {
    setLoading(true);

    const updatedLabels = {
      language_front_arr: JSON.stringify(menuData.front_error_labels),
      language_admin_arr: JSON.stringify(menuData.admin_labels),
      language_error_arr: JSON.stringify(menuData.error_labels),
      language_extra_arr: JSON.stringify(menuData.extra_labels),
      language_front_error_arr: JSON.stringify(menuData.front_error_labels),
      id: selectedLanguage,
    };

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/language_labels.php`,
        { action: "update_language_labels", api_key: "1", ...updatedLabels },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.status === "true") {
        setSuccessMessage("Labels updated successfully!")
        alert("Labels updated successfully");
        fetchLanguages();
      } else {
        alert("Error updating labels: " + response.data.response);
      }
    } catch (error) {
      console.error("Error saving labels:", error);
      alert("Failed to save labels.");
    }   finally {
      setLoading(false);
    }
  };

  const TabButton = ({ tab }) => (
    <button
      onClick={() => setActiveTab(tab)}
      className={`px-2 py-1.5 text-sm md:px-4 md:py-2 md:text-base rounded-t-lg transition-all
        ${activeTab === tab
          ? "bg-blue-500 text-white font-medium"
          : "bg-gray-200 text-gray-600 hover:bg-gray-300"
        } whitespace-nowrap`}
    >
      {tab.replace(/_/g, " ")}
    </button>
  );

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="min-h-screen bg-gray-50 p-2 md:p-6">
           {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      <div className="w-full max-w-6xl mx-auto bg-white rounded-lg shadow-md p-4 md:p-6">
        <h1 className="text-xl md:text-2xl font-bold mb-6 text-gray-800">
          Language Labels Settings
        </h1>

        {/* Language Selection */}
        <div className="mb-6">
          <select
            value={selectedLanguage}
            onChange={handleLanguageChange}
            className="w-full p-2 md:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm md:text-base transition-all"
          >
            <option value="">Select Language</option>
            {languages.map((lang) => (
              <option key={lang.id} value={lang.language}>
                {lang.language}
              </option>
            ))}
          </select>
        </div>

        {selectedLanguage && (
          <div className="space-y-6">
            {/* Tabs and Toggle Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0 border-b border-gray-200 pb-4">
              {/* Tabs */}
              <div className="flex flex-wrap gap-2 w-full md:w-auto">
                {["admin_labels", "app_labels", "error_labels", "extra_labels", "front_error_labels"].map((tab) => (
                  <TabButton key={tab} tab={tab} />
                ))}
                
              </div>

              {/* Toggle Switch */}
              <div className="flex items-center space-x-3 w-full md:w-auto justify-end">
                <span className="text-sm md:text-base text-gray-600">
                  Language Status
                </span>
                <div
                  onClick={handleToggle}
                  className={`relative inline-flex h-6 md:h-7 w-11 md:w-14 items-center rounded-full transition-colors ease-in-out duration-200 cursor-pointer
                    ${isChecked ? "bg-green-500" : "bg-gray-300"}`}
                >
                  <span
                    className={`inline-block h-5 md:h-6 w-5 md:w-6 transform rounded-full bg-white shadow transition-transform duration-200 ease-in-out
                      ${isChecked ? "translate-x-5 md:translate-x-7" : "translate-x-1"}`}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end ">
              <button
                onClick={handleSave}
                className="w-full md:w-auto px-6 py-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:ring-4 focus:ring-blue-300 text-sm md:text-base font-medium transition-all duration-200 ease-in-out"
              >
                Save Changes
              </button>
            </div>

            {/* Labels Content */}
            <div className="space-y-4">
              
              {Object.entries(menuData[activeTab] || {}).length > 0 ? (
                <div className="grid gap-4">
                  {Object.entries(menuData[activeTab]).map(([key, value]) => (
                    <div
                      key={key}
                      className="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-4"
                    >
                      <label className="w-full md:w-1/4 text-sm md:text-base font-medium text-gray-700">
                        {key.replace(/_/g, " ")}
                      </label>
                      <input
                        type="text"
                        value={value}
                        onChange={(e) => {
                          setMenuData((prevData) => ({
                            ...prevData,
                            [activeTab]: {
                              ...prevData[activeTab],
                              [key]: e.target.value,
                            },
                          }));
                        }}
                        className="w-full md:w-3/4 p-2 md:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm md:text-base transition-all"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-gray-500 py-4">
                  No data available for this tab.
                </p>
              )}
            </div>

            {/* Save Button */}
            <div className="flex  pt-4 border-t border-gray-200">
              <button
                onClick={handleSave}
                className="w-full md:w-auto px-6 py-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:ring-4 focus:ring-blue-300 text-sm md:text-base font-medium transition-all duration-200 ease-in-out"
              >
                Save Changes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>

  </div>
  );
};

export default LabelsSettings;



// import axios from "axios";
// import { unserialize } from "php-serialize";
// import { Buffer } from "buffer";
// window.Buffer = Buffer;

// const LabelsSettings = () => {
//   const [languages, setLanguages] = useState([]);
//   console.log(languages)
//   const [selectedLanguage, setSelectedLanguage] = useState("");
//   const [menuData, setMenuData] = useState({});
//   const [activeTab, setActiveTab] = useState("admin_labels");
//   const [decodedLanguages, setDecodedLanguages] = useState([]);
//   const [languageStatus, setLanguageStatus] = useState("");
//   const [inputValues, setInputValues] = useState({});
//   const [isChecked, setIsChecked] = useState(false);
//   const [newState, setnewState] = useState("N");
// console.log(newState);


// const handleToggle = async () => {
//   // Compute the new state directly
//   const newState = !isChecked; 
//   const newStateValue = newState ? "Y" : "N";

//   // Update state immediately
//   setIsChecked(newState);

//   try {
//     // Define the request payload
//     const payload = {
//       action: "change_language_status", // Action to fetch all services
//       lang: selectedLanguage,          // Selected language
//       language_status: newStateValue,  // Updated status as Y/N
//     };

//     // Make the POST request with the payload
//     const response = await axios.post(
//       "http://10.27.1.112:80/megaclean/backend/api/language_labels.php",
//       JSON.stringify(payload), // Request body should be stringified
//       {
//         headers: {
//           "Content-Type": "application/json", // Specify JSON format
//         },
//       }
//     );

//     // Handle API response
//     if (response.data) {
//       console.log("API Response:", response.data);
//     } else {
//       console.log("API response indicates failure:", response.data);
//     }
//   } catch (error) {
//     console.log("Error making API request:", error);
//   }
// };


//   useEffect(() => {
//     fetchLanguages();
//   }, []);

//   const decodeBase64 = (base64String) => {
//     try {
//       return atob(base64String);
//     } catch (error) {
//       console.error("Error decoding Base64:", error);
//       return null;
//     }
//   };

//   const fetchLanguages = async () => {
//     try {
//       const response = await axios.post(
//         "http://10.27.1.112:80/megaclean/backend/api/language_labels.php",
//         { action: "get_all_languages", api_key: "1" },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       const rawData = response.data.data;

//       console.log(rawData)

//       const processedData = rawData.map((language) => ({
//         ...language,
//         admin_labels: language.admin_labels
//           ? unserialize(decodeBase64(language.admin_labels))
//           : {},
//         app_labels: language.app_labels
//           ? unserialize(decodeBase64(language.app_labels))
//           : {},
//         error_labels: language.error_labels
//           ? unserialize(decodeBase64(language.error_labels))
//           : {},
//         extra_labels: language.extra_labels
//           ? unserialize(decodeBase64(language.extra_labels))
//           : {},
//         front_error_labels: language.label_data
//           ? unserialize(decodeBase64(language.label_data))
//           : {},
//       }));

//       setDecodedLanguages(processedData);
//       setLanguages(processedData);
//     } catch (error) {
//       console.error("Error fetching languages:", error);
//     }
//   };

//   const handleInputChange = (field, value) => {
//     setInputValues((prev) => ({
//       ...prev,

//       [field]: value,
//     }));
//   };

//   const toggleLanguageStatus = async (id) => {
//     try {
//       // Define the request payload
//       const payload = {
//         action: "change_language_status", // Action to fetch all services
//         lang: selectedLanguage,
//         language_status: newState,
//       };

//       // Make the POST request with the payload
//       const response = await axios.post(
//         "http://10.27.1.112:80/megaclean/backend/api/language_labels.php",
//         payload, // Request body
//         {
//           headers: {
//             "Content-Type": "application/json", // Specify JSON format
//           },
//         }
//       );

//       console.log(response);

//       // Check if the response contains valid data
//       if (response.data) {
//         const services = response.data;
//         console.log(services);
//       } else {
//         console.log("API response indicates failure:", response.data);
//       }

//     } catch (error) {
//       console.log("Error fetching data:", error);
//     }
//   };

//   // useEffect(() => {
//   //   toggleLanguageStatus();
//   // })


//   const handleLanguageChange = (e) => {
//     const language = e.target.value;
//     setSelectedLanguage(language);

//     console.log("Selected Language:", language); 
//     const selectedLangData = decodedLanguages.find(
//       (lang) => lang.language === language
//     );

//     if (selectedLangData) {
//       setMenuData({
//         admin_labels: selectedLangData.admin_labels || {},
//         app_labels: selectedLangData.app_labels || {},
//         error_labels: selectedLangData.error_labels || {},
//         extra_labels: selectedLangData.extra_labels || {},
//         front_error_labels: selectedLangData.front_error_labels || {},
//       });
//       setActiveTab("admin_labels");
//       setLanguageStatus(selectedLangData.language_status);
//     }
//   };

//   const handleStatusChange = async () => {
//     const newStatus = languageStatus === "active" ? "inactive" : "active";

//     try {
//       const response = await axios.post(
//         "http://10.27.1.112:80/megaclean/backend/api/language_labels.php",
//         {
//           action: "update_language_status",
//           api_key: "1",
//           lang: selectedLanguage,
//           status: newStatus,
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       if (response.data.status === "true") {
//         setLanguageStatus(newStatus);
//         alert("Language status updated successfully.");
//       } else {
//         alert("Error updating language status: " + response.data.response);
//       }
//     } catch (error) {
//       console.error("Error updating language status:", error);
//       alert("Failed to update language status.");
//     }
//   };

//   const handleSave = async () => {
//     const updatedLabels = {
//       language_front_arr: JSON.stringify(menuData.front_error_labels),
//       language_admin_arr: JSON.stringify(menuData.admin_labels),
//       language_error_arr: JSON.stringify(menuData.error_labels),
//       language_extra_arr: JSON.stringify(menuData.extra_labels),
//       language_front_error_arr: JSON.stringify(menuData.front_error_labels),
//       id: selectedLanguage,
//     };

//     try {
//       const response = await axios.post(
//         "http://10.27.1.112:80/megaclean/backend/api/language_labels.php",
//         { action: "update_language_labels", api_key: "1", ...updatedLabels },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       if (response.data.status === "true") {
//         alert("Labels updated successfully");
//         fetchLanguages();
//       } else {
//         alert("Error updating labels: " + response.data.response);
//       }
//     } catch (error) {
//       console.error("Error saving labels:", error);
//       alert("Failed to save labels.");
//     }
//   };

//   return (
//     <div className="w-full max-w-6xl mx-auto p-6 bg-white rounded-lg shadow-md">
//       <h1 className="text-2xl font-bold mb-4">Language Labels</h1>

//       <select
//         value={selectedLanguage}
//         onChange={handleLanguageChange}
//         className="p-2 border rounded mb-4 w-full"
//       >
//         <option value="">Select Language</option>
//         {languages.map((lang) => (
//           <option key={lang.id} value={lang.language}>
//             {lang.language}
//           </option>
//         ))}
//       </select>
// {/* 
//       {selectedLanguage && (
//         <div className="mb-4 flex items-center">
//           <span className="mr-4 font-bold">Status:</span>
//           <div className="flex items-center justify-end space-x-4">
     
//               <div
//                 onClick={handleToggle}
//                 className={`w-14 h-8 rounded-full ${
//                   isChecked ? "bg-green-500" : "bg-gray-300"
//                 } relative cursor-pointer transition-all`}
//               >
              
//                 <div
//                   className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full transition-transform ${
//                     isChecked ? "translate-x-6" : ""
//                   }`}
//                 ></div>
//               </div>
//             </div>
//         </div>
//       )} */}

//       {selectedLanguage && (
//         <div>
//           <div className="flex justify-between items-center mb-6 border-b pb-2">
//   {/* Left side labels */}
//   <div className="flex flex-wrap gap-4">
//     {["admin_labels", "app_labels", "error_labels", "extra_labels", "front_error_labels"].map((tab) => (
//       <button
//         key={tab}
//         onClick={() => setActiveTab(tab)}
//         className={`px-4 py-2 rounded-t ${
//           activeTab === tab
//             ? "bg-blue-500 text-white"
//             : "bg-gray-200 text-gray-600"
//         }`}
//       >
//         {tab.replace(/_/g, " ")}
//       </button>
//     ))}
//   </div>

//   {/* Right side toggle button */}
//   <div
//     onClick={handleToggle}
//     className={`w-14 h-8 rounded-full ${
//       isChecked ? "bg-green-500" : "bg-gray-300"
//     } relative cursor-pointer transition-all`}
//   >
//     {/* Ball inside the toggle */}
//     <div
//       className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full transition-transform ${
//         isChecked ? "translate-x-6" : ""
//       }`}
//     ></div>
//   </div>
// </div>


//           <div className="mt-4">
//             {Object.entries(menuData[activeTab] || {}).length > 0 ? (
//               Object.entries(menuData[activeTab]).map(([key, value]) => (
//                 <div key={key} className="mb-2 flex items-center">
//                   <strong className="w-1/4 text-left">{key.replace(/_/g, " ")}</strong>
//                   <input
//                     type="text"
//                     value={value}
//                     onChange={(e) => {
//                       setMenuData((prevData) => ({
//                         ...prevData,
//                         [activeTab]: {
//                           ...prevData[activeTab],
//                           [key]: e.target.value,
//                         },
//                       }));
//                     }}
//                     className="w-3/4 p-2 border rounded"
//                   />
//                 </div>
//               ))
//             ) : (
//               <p>No data available for this tab.</p>
//             )}
//           </div>
//         </div>
//       )}

//       <button
//         onClick={handleSave}
//         className="mt-6 p-2 bg-blue-500 text-white rounded"
//       >
//         Save
//       </button>
//     </div>
//   );
// };

// export default LabelsSettings;




// import React, { useState } from "react";

// const Labels_Settings = () => {
//   // Languages array

//   const languages = ["English", "Spanish", "French", "German", "Italian"];

//   // Menus and fields for each language

//   const languageMenus = {
//     English: [
//       {
//         name: "Frontend Labels",
//         fields: [
//           "none_available",
//           "appointment_zip",
//           "appointment_city",
//           "appointment_state",
//           "appointment_address",
//           "guest_user",
//           "service_usage_methods",
//           "paypal",
//           "please_check_missing_info",
//           "provide_company_details_admin",
//           "add_services_methods_units_addons",
//           "add_time_scheduling",
//           "complete_configurations",
//           "cvc",
//           "mm_yyyy",
//           "expiry_date_or_csv",
//           "street_address_placeholder",
//           "zip_code_placeholder",
//           "city_placeholder",
//           "state_placeholder",
//           "payumoney",
//           "same_as_above",
//           "sun",
//           "mon",
//           "tue",
//           "wed",
//           "thu",
//           "fri",
//           "sat",
//           "su",
//           "mo",
//           "tu",
//           "we",
//           "th",
//           "fr",
//           "sa",
//           "my_bookings",
//           "your_postal_code",
//           "where_provide_service",
//           "choose_service",
//           "how_often_service",
//           "when_would_you_like_us_come",
//           "today",
//           "your_personal_details",
//           "existing_user",
//           "new_user",
//           "preferred_email",
//           "preferred_password",
//           "valid_email_address",
//           "first_name",
//           "your_first_name",
//           "last_name",
//           "your_last_name",
//           "street_address",
//           "cleaning_service",
//           "please_select_method",
//           "zip_code",
//           "city",
//           "state",
//           "special_requests_notes",
//           "do_you_have_vacuum",
//           "assign_appointment_to_staff",
//           "delete_member",
//           "yes",
//           "no",
//           "preferred_payment_method",
//           "please_select_payment_method",
//           "partial_deposit",
//           "remaining_amount",
//           "read_terms_conditions",
//           "do_you_have_parking",
//           "how_will_we_get_in",
//           "i_will_be_at_home",
//           "please_call_me",
//           "recurring_discounts",
//           "provide_address_contact_details",
//           "logged_in_as",
//           "key_with_doorman",
//           "other",
//           "have_promocode",
//           "apply",
//           "applied_promocode",
//           "complete_booking",
//           "cancellation_policy",
//           "cancellation_policy_header",
//           "cancellation_policy_textarea",
//           "free_cancellation_before_redemption",
//           "show_more",
//           "please_select_service",
//           "choose_service_property_size",
//           "please_configure_first_cleaning",
//           "read_accepted_terms",
//           "updated_labels",
//           "privacy_policy",
//           "fill_company_information",
//           "booking_summary",
//           "your_email",
//           "enter_email_to_login",
//           "your_password",
//           "enter_password",
//           "forget_password",
//           "reset_password",
//           "instructions_reset_password",
//           "registered_email",
//           "send_mail",
//           "back_to_login",
//           "your_clean_items",
//           "cart_is_empty",
//           "sub_total_tax",
//           "sub_total",
//           "no_data_available",
//           "total",
//           "or",
//           "select_addon_image",
//           "inside_fridge",
//           "inside_oven",
//           "inside_windows",
//           "carpet_cleaning",
//           "green_cleaning",
//           "pets_care",
//           "tiles_cleaning",
//           "wall_cleaning",
//           "laundry",
//           "basement_cleaning",
//           "basic_price",
//           "max_qty",
//           "multiple_qty",
//           "base_price",
//           "unit_pricing",
//           "method_is_booked",
//           "service_addons_price_rules",
//           "service_unit_front_dropdown",
//           "service_unit_front_block",
//           "service_unit_front_increase_decrease",
//           "are_you_sure",
//           "service_unit_price_rules",
//           "close",
//           "closed",
//           "service_addons",
//           "service_enable",
//           "service_disable",
//           "method_enable",
//           "off_time_deleted",
//           "error_delete_off_time",
//           "method_disable",
//           "extra_services",
//           "initial_cleaning_only",
//           "number_of",
//           "extra_services_not_available",
//           "available",
//           "selected",
//           "not_available",
//           "none",
//           "no_time_slot_available",
//           "availability_not_configured",
//           "how_many_intensive",
//           "no_intensive",
//           "frequently_discount",
//           "coupon_discount",
//           "how_many",
//           "existing",
//           "send_booking_confirmation",
//           "send_confirmation",
//         ],
//       },

//       { name: "Admin Labels", fields: ["special discount	", "edit customer detail", "preferred email","preferred password","update special offer","offer date"] },

//       {
//         name: "Errors",
//         fields: ["language status change successfully", "commission amount should not be greater then order amount", "please enter merchant ID","please enter secure key","please enter google calender admin url","please enter google calender frontend url","please enter google calender client secret"],
//       },

//       { name: "Extra Labels", fields: ["please enter minimum 3 chars	", "invoice", "invoice to ","invoice date","cash" ,"service name","qty","booked on"]},
//       { name: "App Labels", fields: ["welcome", "make your online appointment", "skip","scheduling","make your online appointment scheduling super easy","get started","get started by logging in or by signing up"] },
//     ],

//     Spanish: [
//       {
//         name: "Frontend Labels",
//         fields: [
//           "none_available",
//           "appointment_zip",
//           "appointment_city",
//           "appointment_state",
//           "appointment_address",
//           "guest_user",
//           "service_usage_methods",
//           "paypal",
//           "please_check_missing_info",
//           "provide_company_details_admin",
//           "add_services_methods_units_addons",
//           "add_time_scheduling",
//           "complete_configurations",
//           "cvc",
//           "mm_yyyy",
//           "expiry_date_or_csv",
//           "street_address_placeholder",
//           "zip_code_placeholder",
//           "city_placeholder",
//           "state_placeholder",
//           "payumoney",
//           "same_as_above",
//           "sun",
//           "mon",
//           "tue",
//           "wed",
//           "thu",
//           "fri",
//           "sat",
//           "su",
//           "mo",
//           "tu",
//           "we",
//           "th",
//           "fr",
//           "sa",
//           "my_bookings",
//           "your_postal_code",
//           "where_provide_service",
//           "choose_service",
//           "how_often_service",
//           "when_would_you_like_us_come",
//           "today",
//           "your_personal_details",
//           "existing_user",
//           "new_user",
//           "preferred_email",
//           "preferred_password",
//           "valid_email_address",
//           "first_name",
//           "your_first_name",
//           "last_name",
//           "your_last_name",
//           "street_address",
//           "cleaning_service",
//           "please_select_method",
//           "zip_code",
//           "city",
//           "state",
//           "special_requests_notes",
//           "do_you_have_vacuum",
//           "assign_appointment_to_staff",
//           "delete_member",
//           "yes",
//           "no",
//           "preferred_payment_method",
//           "please_select_payment_method",
//           "partial_deposit",
//           "remaining_amount",
//           "read_terms_conditions",
//           "do_you_have_parking",
//           "how_will_we_get_in",
//           "i_will_be_at_home",
//           "please_call_me",
//           "recurring_discounts",
//           "provide_address_contact_details",
//           "logged_in_as",
//           "key_with_doorman",
//           "other",
//           "have_promocode",
//           "apply",
//           "applied_promocode",
//           "complete_booking",
//           "cancellation_policy",
//           "cancellation_policy_header",
//           "cancellation_policy_textarea",
//           "free_cancellation_before_redemption",
//           "show_more",
//           "please_select_service",
//           "choose_service_property_size",
//           "please_configure_first_cleaning",
//           "read_accepted_terms",
//           "updated_labels",
//           "privacy_policy",
//           "fill_company_information",
//           "booking_summary",
//           "your_email",
//           "enter_email_to_login",
//           "your_password",
//           "enter_password",
//           "forget_password",
//           "reset_password",
//           "instructions_reset_password",
//           "registered_email",
//           "send_mail",
//           "back_to_login",
//           "your_clean_items",
//           "cart_is_empty",
//           "sub_total_tax",
//           "sub_total",
//           "no_data_available",
//           "total",
//           "or",
//           "select_addon_image",
//           "inside_fridge",
//           "inside_oven",
//           "inside_windows",
//           "carpet_cleaning",
//           "green_cleaning",
//           "pets_care",
//           "tiles_cleaning",
//           "wall_cleaning",
//           "laundry",
//           "basement_cleaning",
//           "basic_price",
//           "max_qty",
//           "multiple_qty",
//           "base_price",
//           "unit_pricing",
//           "method_is_booked",
//           "service_addons_price_rules",
//           "service_unit_front_dropdown",
//           "service_unit_front_block",
//           "service_unit_front_increase_decrease",
//           "are_you_sure",
//           "service_unit_price_rules",
//           "close",
//           "closed",
//           "service_addons",
//           "service_enable",
//           "service_disable",
//           "method_enable",
//           "off_time_deleted",
//           "error_delete_off_time",
//           "method_disable",
//           "extra_services",
//           "initial_cleaning_only",
//           "number_of",
//           "extra_services_not_available",
//           "available",
//           "selected",
//           "not_available",
//           "none",
//           "no_time_slot_available",
//           "availability_not_configured",
//           "how_many_intensive",
//           "no_intensive",
//           "frequently_discount",
//           "coupon_discount",
//           "how_many",
//           "existing",
//           "send_booking_confirmation",
//           "send_confirmation",
//         ],
//       },

//       { name: "Admin Labels", fields: ["special discount	", "edit customer detail", "preferred email","preferred password","update special offer","offer date"] },

//       {
//         name: "Errors",
//         fields: ["language status change successfully", "commission amount should not be greater then order amount", "please enter merchant ID","please enter secure key","please enter google calender admin url","please enter google calender frontend url","please enter google calender client secret"],
//       },

//       { name: "Extra Labels", fields: ["please enter minimum 3 chars	", "invoice", "invoice to ","invoice date","cash" ,"service name","qty","booked on"]},
      
//       { name: "Front Error Labels", fields: ["please enter minimum 3 chars	", "invoice", "invoice to ","invoice date","cash" ,"service name","qty","booked on"]},
//       { name: "App Labels", fields: ["welcome", "make your online appointment", "skip","scheduling","make your online appointment scheduling super easy","get started","get started by logging in or by signing up"] },
    
//     ],

//     French: [
//       {
//         name: "Informations Personnelles",
//         fields: ["Prénom", "Nom", "E-mail"],
//       },

//       { name: "Adresse", fields: ["Rue", "Ville", "Code Postal","Rue", "Ville", "Code Postal"] },

//       {
//         name: "Emploi",
//         fields: ["Entreprise", "Poste", "Années d'Expérience","Entreprise", "Poste", "Années d'Expérience"],
//       },

//       { name: "Éducation", fields: ["Diplôme", "Spécialité", "Université","Diplôme", "Spécialité", "Université"] },
//     ],

//     German: [
//       {
//         name: "Persönliche Informationen",
//         fields: ["Vorname", "Nachname", "E-Mail","Vorname", "Nachname", "E-Mail","Vorname", "Nachname", "E-Mail"],
//       },

//       { name: "Adresse", fields: ["Straße", "Stadt", "Postleitzahl","Straße", "Stadt", "Postleitzahl","Straße", "Stadt", "Postleitzahl"] },

//       {
//         name: "Beschäftigung",
//         fields: ["Unternehmen", "Position", "Berufserfahrung","Unternehmen", "Position", "Berufserfahrung"],
//       },

//       { name: "Bildung", fields: ["Abschluss", "Fachrichtung", "Universität","Abschluss", "Fachrichtung", "Universität","Abschluss", "Fachrichtung", "Universität"] },
//     ],

//     Italian: [
//       { name: "Informazioni Personali", fields: ["Nome", "Cognome", "Email","Nome", "Cognome", "Email","Nome", "Cognome", "Email"] },

//       { name: "Indirizzo", fields: ["Via", "Città", "Codice Postale","Via", "Città", "Codice Postale","Via", "Città", "Codice Postale"] },

//       {
//         name: "Impiego",
//         fields: ["Azienda", "Posizione", "Anni di Esperienza","Azienda", "Posizione", "Anni di Esperienza"],
//       },

//       {
//         name: "Istruzione",
//         fields: ["Laurea", "Specializzazione", "Università","Laurea", "Specializzazione", "Università","Laurea", "Specializzazione", "Università"],
//       },
//     ],
//   };

//   // State for selected language and active menu

//   const [selectedLanguage, setSelectedLanguage] = useState("");

//   const [activeMenu, setActiveMenu] = useState(null);

//   const [inputValues, setInputValues] = useState({});

//   const [isChecked, setIsChecked] = useState(false);

//   const handleToggle = () => {
//     setIsChecked((prevState) => !prevState);
//   };

//   // Handle language selection

//   const handleLanguageChange = (e) => {
//     const language = e.target.value;

//     setSelectedLanguage(language);

//     setActiveMenu(null);

//     setInputValues({});
//   };

//   // Handle menu selection

//   const handleMenuSelect = (menuName) => {
//     setActiveMenu(menuName);
//   };

//   // Handle input change

//   const handleInputChange = (field, value) => {
//     setInputValues((prev) => ({
//       ...prev,

//       [field]: value,
//     }));
//   };

//   return (
//     <div className="mx-auto p-4 bg-white rounded-lg shadow-md w-full md:w-3/4 lg:w-3/4  xl:w-2/3">
//       {/* Language Dropdown */}

//       <select
//         value={selectedLanguage}
//         onChange={handleLanguageChange}
//         className="w-full p-2 mb-4 border rounded"
//       >
//         <option value="">Select a Language</option>

//         {languages.map((lang) => (
//           <option key={lang} value={lang}>
//             {lang}
//           </option>
//         ))}
//       </select>

//       {/* Menus and Fields */}

//       {selectedLanguage && (
//         <div>
//           {/* Menu Buttons */}

//           <div className="flex flex-wrap justify-between mb-4 space-x-2">
//             {/* Left side: Language menu buttons */}
//             <div className="flex flex-wrap space-x-2 mb-4 sm:mb-0">
//               {languageMenus[selectedLanguage].map((menu) => (
//                 <button
//                   key={menu.name}
//                   onClick={() => handleMenuSelect(menu.name)}
//                   className={`px-4 py-2  rounded-xl ${
//                     activeMenu === menu.name
//                       ? "bg-blue-500 text-white"
//                       : "bg-gray-200 text-gray-700"
//                   }`}
//                 >
//                   {menu.name}
//                 </button>
//               ))}
//             </div>

//             {/* Right side: Toggle button */}
//             <div className="flex items-center justify-end space-x-4">
//               {/* The toggle button */}
//               <div
//                 onClick={handleToggle}
//                 className={`w-14 h-8 rounded-full ${
//                   isChecked ? "bg-green-500" : "bg-gray-300"
//                 } relative cursor-pointer transition-all`}
//               >
//                 {/* Ball inside the toggle */}
//                 <div
//                   className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full transition-transform ${
//                     isChecked ? "translate-x-6" : ""
//                   }`}
//                 ></div>
//               </div>
//             </div>
//           </div>

//           {/* Fields for Active Menu */}

//           {activeMenu && (
//             <div className="bg-white p-4 rounded">
             
//              <h3 className="text-xl font-semibold">{activeMenu}</h3>

//               {/* Render form fields based on the active menu */}
//               {languageMenus[selectedLanguage]
//                 .find((menu) => menu.name === activeMenu)
//                 .fields.map((field) => (
//                   <div
//                     key={field}
//                     className="mb-3 flex items-center justify-between"
//                   >
//                     {/* Label on the left */}
//                     <label className="text-sm font-medium text-gray-700 mb-1 w-1/3">
//                       {field}
//                     </label>

//                     {/* Input on the right */}
//                     <input
//                       type="text"
//                       value={inputValues[field] || ""}
//                       onChange={(e) => handleInputChange(field, e.target.value)}
//                       className="w-2/3 p-2 border rounded focus:ring-2 focus:ring-blue-500"
//                       placeholder={`Enter ${field}`}
//                     />
//                   </div>

                  
//                 ))}
               

//                 {/* Save button on the right */}
//                 <button className="bg-blue-500 text-white py-2 px-4 rounded">
//                   Save
//                 </button>
           
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Labels_Settings;

